
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '@/hooks/use-mobile';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import ProcessPhases from './ProcessPhases';
import TechBackground from '@/components/ui/TechBackground';

const DevelopmentPipeline = () => {
  const isMobile = useIsMobile();
  const [activePhase, setActivePhase] = useState(0);
  
  // Scrolls smoothly to the contact section
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const navbarHeight = 64;
      const offsetTop = contactSection.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  };

  return (
    <div className="w-full">
      {/* Title section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className="mb-6 text-center md:text-left"
      >
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white flex flex-col md:flex-row items-center md:items-baseline gap-2">
          <span>Development</span>
          <span className="text-[#10B981] italic font-medium">Pipeline</span>
        </h2>
        
        <motion.div 
          className="h-1 w-16 md:w-24 bg-[#10B981] mx-auto md:mx-0 mt-2"
          initial={{ width: 0 }}
          whileInView={{ width: isMobile ? '4rem' : '6rem' }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        />
      </motion.div>

      <TechBackground variant="dark" glow="green">
        <div className="p-4 md:p-6">
          <ProcessPhases activePhase={activePhase} setActivePhase={setActivePhase} />
        </div>
        
        {/* Call to action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-6 md:mt-8 text-center"
        >
          <Button
            onClick={scrollToContact}
            size="lg"
            className="bg-[#10B981] text-white hover:bg-[#0D9668] px-8 shadow-md hover:shadow-lg transition-all duration-300"
          >
            Start Your Project
            <motion.span
              animate={{ x: [0, 5, 0] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
              className="ml-2"
            >
              <ArrowRight className="h-5 w-5" />
            </motion.span>
          </Button>
        </motion.div>
      </TechBackground>
    </div>
  );
};

export default DevelopmentPipeline;
